import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";

import { companyService } from "services";
import { errorFormating, getSubscription } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as companyActions from "actions/companyActions";
import { isTrial, getTrialDays } from "utils/utils";
import Switch from "components/Switch";
import { authService } from "../../services/authService";
import { getAppName } from 'utils/utils';

class SubscriptionRequest extends React.Component {
	constructor(props) {
		super(props);

		let subscription_request = {
			subscription_type: props.selected_plan.name,
			how_did_you_know_us: "",
			observations: "",
			company: this.props.company,
		};

		this.state = {
			isLoading: false,
			submitted: false,
			isYearly: props.isYearly,
			maxUsers: props.employees_count,
			step: 0,
			errors: {},
			current_subscription: getSubscription(),
			subscription_request,
		};
	}

	handleChange = (event) => {
		const { subscription_request } = this.state;
		const company = subscription_request.company;
		let target = event.target.id;
		let value = event.target.value;

		if (target.includes("company")) {
			target = target.replace("company.", "");
			this.setState({
				subscription_request: {
					...subscription_request,
					company: { ...company, [target]: value },
				},
			});
		} else {
			this.setState({
				subscription_request: { ...subscription_request, [event.target.id]: value },
			});
		}
	};

	handleEmployeeChange = (event) => {
		this.setState({ maxUsers: event.target.value });
	};

	handleSwitch = (event) => {
		this.setState({ isYearly: event.target.checked });
	};

	setStep(step) {
		this.setState({ step });
	}

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		const props = this.props;
		const { subscription_request, isYearly, maxUsers } = this.state;

		this.setState({ isLoading: true });

		if (subscription_request.subscription_type === "Pro") {
			subscription_request.payment_model = isYearly ? "Anual" : "Mensual";
			subscription_request.max_users = maxUsers;
		}

		const response = await companyService.addSubscriptionRequest(subscription_request);
		subscription_request.how_did_you_know_us = "XXX";

		if (response.ok) {
			this.setState(
				{ isLoading: false, errors: {}, step: 2 },
				async () => {
					if (subscription_request.subscription_type === "Free") {
						await authService.setUser(props.user);
					}
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	getStep0Content() {
		const { t, selected_plan, employees_count } = this.props;
		const { isYearly, maxUsers } = this.state;

		if (selected_plan.name !== "Pro") {
			return (
				<div className="step-content step-content-free">
					<h3>{t('subscription.trialPlanTitle')}</h3>
					<p>{t('subscription.trialPlanDescription')}</p>
				</div>
			);
		}

		const employeesOptionList = Array(3000 - employees_count + 1)
			.fill()
			.map((_, i) => (
				<option key={employees_count + i} value={employees_count + i}>
					{employees_count + i}
				</option>
			));

		var userAmount = 4;
		var total = (maxUsers * userAmount)
			.toFixed(2)
			.toString()
			.replace(".00", "")
			.replace(".", ",");

		return (
			<div className="step-content">
				<h3>Plan Pro</h3>
				<p>{t('subscription.proPlanDescription')}</p>

				<div className="row-switch row-switch-double">
					<span className={`label-mensual label-switch ${!isYearly ? "active" : ""}`}>
						<span className="hidden-xs">{t('subscription.paymentPrefix')}</span>
						{t('subscription.quarterlyLabel')}
					</span>

					<Switch
						controlId="isYearlyModal"
						isOn={isYearly}
						handleToggle={this.handleSwitch}
					/>

					<span className={`label-anual label-switch ${isYearly ? "active" : ""}`}>
						<span className="hidden-xs">{t('subscription.paymentPrefix')}</span>
						{t('subscription.annualLabel')}
						<span className="oferta hidden"> {t('subscription.discount')}</span>
					</span>
				</div>

				<div className="row-empleados">
					<FormGroup className="form-group" controlId="maxUsers">
						<FormLabel>
							{t('subscription.employees')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							onChange={this.handleEmployeeChange}
							value={maxUsers}
							isInvalid={this.checkValidField("max_users")}
							as="select"
						>
							{employeesOptionList}
						</FormControl>
						<FormControl.Feedback type="invalid">
							{this.state.errors.max_users}
						</FormControl.Feedback>
					</FormGroup>

					<div className="total">
						<span className="total-label">{t('subscription.total')}</span>
						<span className="total-num">{total}€</span>
					</div>
				</div>
			</div>
		);
	}

	getStep1Content() {
		const { t, countries, user } = this.props;
		const { subscription_request, errors } = this.state;
		const company = subscription_request.company;
		const currentSubscription = user.subscription.subscription_type.name;

		const countriesOptionList =
			countries.length > 0 &&
			countries.map((item, i) => (
				<option key={i} value={item.iso}>{item.name}</option>
			));

		return (
			<>
				<p className="intro">{t('subscription.fillFormIntro')}</p>
				<Row>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.name">
							<FormLabel>{t('subscription.companyName')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.name}
								onChange={this.handleChange}
								placeholder={t('subscription.companyNamePlaceholder')}
								isInvalid={this.checkValidField("name")}
							/>
							<FormControl.Feedback type="invalid">{errors.name}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.vat_number">
							<FormLabel>{t('subscription.vatNumber')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.vat_number}
								onChange={this.handleChange}
								placeholder={t('subscription.vatNumberPlaceholder')}
								isInvalid={this.checkValidField("vat_number")}
							/>
							<FormControl.Feedback type="invalid">{errors.vat_number}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.phone">
							<FormLabel>{t('subscription.phone')}</FormLabel>
							<FormControl
								type="text"
								value={company.phone}
								onChange={this.handleChange}
								placeholder={t('subscription.phonePlaceholder')}
								isInvalid={this.checkValidField("phone")}
							/>
							<FormControl.Feedback type="invalid">{errors.phone}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.address">
							<FormLabel>{t('subscription.address')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.address}
								onChange={this.handleChange}
								placeholder={t('subscription.addressPlaceholder')}
								isInvalid={this.checkValidField("address")}
							/>
							<FormControl.Feedback type="invalid">{errors.address}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.postal_code">
							<FormLabel>{t('subscription.postalCode')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.postal_code}
								onChange={this.handleChange}
								placeholder={t('subscription.postalCodePlaceholder')}
								isInvalid={this.checkValidField("postal_code")}
							/>
							<FormControl.Feedback type="invalid">{errors.postal_code}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.city">
							<FormLabel>{t('subscription.city')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.city}
								onChange={this.handleChange}
								placeholder={t('subscription.cityPlaceholder')}
								isInvalid={this.checkValidField("city")}
							/>
							<FormControl.Feedback type="invalid">{errors.city}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.province">
							<FormLabel>{t('subscription.province')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.province}
								onChange={this.handleChange}
								placeholder={t('subscription.provincePlaceholder')}
								isInvalid={this.checkValidField("province")}
							/>
							<FormControl.Feedback type="invalid">{errors.province}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.country_iso">
							<FormLabel>{t('subscription.country')} <span className="label-required">*</span></FormLabel>
							<FormControl
								onChange={this.handleChange}
								value={company.country_iso}
								isInvalid={this.checkValidField("country_iso")}
								as="select"
							>
								<option value="-1">{t('subscription.selectCountry')}</option>
								{countriesOptionList}
							</FormControl>
							<FormControl.Feedback type="invalid">{errors.country_iso}</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="company.email">
							<FormLabel>E-mail <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={company.email}
								onChange={this.handleChange}
								placeholder={t('subscription.emailPlaceholder')}
								isInvalid={this.checkValidField("email")}
							/>
							<FormControl.Feedback type="invalid">{errors.email}</FormControl.Feedback>
						</FormGroup>
					</Col>
				</Row>

				{currentSubscription !== "Pro" && (
					<FormGroup className="form-group" controlId="how_did_you_know_us">
						<FormLabel>{t('subscription.howDidYouKnowUs')} <span className="label-required">*</span></FormLabel>
						<FormControl
							type="text"
							value={subscription_request.how_did_you_know_us}
							onChange={this.handleChange}
							placeholder={t('subscription.howDidYouKnowUsPlaceholder')}
							isInvalid={this.checkValidField("how_did_you_know_us")}
						/>
						<FormControl.Feedback type="invalid">{errors.how_did_you_know_us}</FormControl.Feedback>
					</FormGroup>
				)}

				<FormGroup className="form-group" controlId="observations">
					<FormLabel>{t('subscription.observations')}</FormLabel>
					<FormControl
						type="text"
						value={subscription_request.observations}
						onChange={this.handleChange}
						placeholder={t('subscription.observationsPlaceholder')}
						isInvalid={this.checkValidField("observations")}
					/>
					<FormControl.Feedback type="invalid">{errors.observations}</FormControl.Feedback>
				</FormGroup>
			</>
		);
	}

	getStep2Content() {
		const { t, selected_plan } = this.props;
		const totalDays = getTrialDays();
		const appName = getAppName();

		if (selected_plan.name !== "Pro") {
			return (
				<div className="step-content">
					<h3>{t('subscription.trialSuccessTitle')}</h3>
					<p dangerouslySetInnerHTML={{
						__html: t('subscription.trialSuccessMessage', { appName, days: totalDays })
					}} />
				</div>
			);
		}

		return (
			<div className="step-content">
				<h3>{t('subscription.proSuccessTitle')}</h3>
				<p>{t('subscription.proSuccessMessage')}</p>
			</div>
		);
	}

	render() {
		const { t, selected_plan } = this.props;
		const { step } = this.state;

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body modal-subscription">
					{step === 0 && this.getStep0Content()}
					{step === 1 && this.getStep1Content()}
					{step === 2 && this.getStep2Content()}
				</div>

				<div className="modal-footer">
					{step === 0 && (
						<>
							<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">
								{t('common.cancel')}
							</button>
							<button type="button" onClick={() => this.setStep(1)} className="btn btn-primary">
								{t('common.next')} <FiChevronRight />
							</button>
						</>
					)}

					{step === 1 && (
						<>
							<button type="button" onClick={() => this.setStep(0)} className="btn btn-outline-primary">
								<FiChevronLeft /> {t('common.back')}
							</button>
							<SubmitButton
								type="submit"
								isLoading={this.state.isLoading}
								text={t('subscription.saveAndSend')}
								loadingText={t('common.saving')}
							/>
						</>
					)}

					{step === 2 && (
						<button
							type="button"
							onClick={() => selected_plan.name === "Free" ? window.location.reload(true) : this.props.handleClose()}
							className="btn btn-outline-primary"
						>
							{t('common.close')}
						</button>
					)}
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => ({
	...reducers.companyReducer,
	user: reducers.authReducer.user,
});

export default connect(mapStateToProps, companyActions)(withTranslation()(SubscriptionRequest));
